import { ReportData } from '../types/reportTypes';

// March 2026 Sales Data - Standard Report (38 jobs from Sales CSV)
// Source: sample csv/2025 TLLG Marketing Leads Report - ROI Exteriors - Sales Mar26.csv
// Trade names: "ROI " prefix stripped, multi-trade entries use first trade only
const jobData = [
  {
    jobInfo: "Elke & William Binter",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 4721.00,
    grossMarginPct: 0.4000,
    grossProfit: 1888.40,
    commissionPercentage: 4.00,
    salesCommission: 188.84,
    salesManagerFee: 47.21,
    companyOH: 731.76,
    netProfit: 0
  },
  {
    jobInfo: "Mariah & Justin Wilder",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 6169.00,
    grossMarginPct: 0.4719,
    grossProfit: 2911.15,
    commissionPercentage: 4.00,
    salesCommission: 246.76,
    salesManagerFee: 61.69,
    companyOH: 956.20,
    netProfit: 0
  },
  {
    jobInfo: "Jeff & Linda Wild",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 2993.00,
    grossMarginPct: 0.5657,
    grossProfit: 1693.14,
    commissionPercentage: 7.00,
    salesCommission: 209.51,
    salesManagerFee: 29.93,
    companyOH: 463.92,
    netProfit: 0
  },
  {
    jobInfo: "Rocky Wilson",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 18967.00,
    grossMarginPct: 0.4847,
    grossProfit: 9193.30,
    commissionPercentage: 4.00,
    salesCommission: 758.68,
    salesManagerFee: 189.67,
    companyOH: 2939.89,
    netProfit: 0
  },
  {
    jobInfo: "E-945: Bobbi .. & Edward Schiff",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 12102.00,
    grossMarginPct: 0.3756,
    grossProfit: 4545.51,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 121.02,
    companyOH: 1875.81,
    netProfit: 0
  },
  {
    jobInfo: "Priscilla & Don Millberry",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 23272.00,
    grossMarginPct: 0.4000,
    grossProfit: 9308.80,
    commissionPercentage: 4.00,
    salesCommission: 930.88,
    salesManagerFee: 232.72,
    companyOH: 3607.16,
    netProfit: 0
  },
  {
    jobInfo: "Noreen & Victor Ferrarelli",
    leadSource: "Referral - From past customer",
    trade: "Gutters",
    contractTotal: 16772.00,
    grossMarginPct: 0.4270,
    grossProfit: 7161.64,
    commissionPercentage: 4.00,
    salesCommission: 670.88,
    salesManagerFee: 167.72,
    companyOH: 2599.66,
    netProfit: 0
  },
  {
    jobInfo: "E-932: Jeffrey & Peggy Hafner",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 4472.00,
    grossMarginPct: 0.4000,
    grossProfit: 1788.80,
    commissionPercentage: 4.00,
    salesCommission: 178.88,
    salesManagerFee: 44.72,
    companyOH: 693.16,
    netProfit: 0
  },
  {
    jobInfo: "E-933: Chante Bonner",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 15000.00,
    grossMarginPct: 0.4336,
    grossProfit: 6504.00,
    commissionPercentage: 4.00,
    salesCommission: 600.00,
    salesManagerFee: 150.00,
    companyOH: 2325.00,
    netProfit: 0
  },
  {
    jobInfo: "E-950: John & Marlene Lucas",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 15416.00,
    grossMarginPct: 0.4000,
    grossProfit: 6166.40,
    commissionPercentage: 4.00,
    salesCommission: 616.64,
    salesManagerFee: 154.16,
    companyOH: 2389.48,
    netProfit: 0
  },
  {
    jobInfo: "E-952: Linda McClellan",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 2677.00,
    grossMarginPct: 0.4000,
    grossProfit: 1070.80,
    commissionPercentage: 4.00,
    salesCommission: 107.08,
    salesManagerFee: 26.77,
    companyOH: 414.94,
    netProfit: 0
  },
  {
    jobInfo: "E-931: Nancie Warren",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 9719.00,
    grossMarginPct: 0.6388,
    grossProfit: 6208.50,
    commissionPercentage: 10.00,
    salesCommission: 971.90,
    salesManagerFee: 97.19,
    companyOH: 1506.45,
    netProfit: 0
  },
  {
    jobInfo: "E-926: Barbara & Greg Estep",
    leadSource: "Referral - From past customer",
    trade: "Windows & Doors",
    contractTotal: 11265.00,
    grossMarginPct: 0.5889,
    grossProfit: 6633.96,
    commissionPercentage: 7.00,
    salesCommission: 788.55,
    salesManagerFee: 112.65,
    companyOH: 1746.08,
    netProfit: 0
  },
  {
    jobInfo: "E-949: Jacky Olive",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 9972.00,
    grossMarginPct: 0.3627,
    grossProfit: 3616.84,
    commissionPercentage: 0.00,
    salesCommission: 0.00,
    salesManagerFee: 99.72,
    companyOH: 1545.66,
    netProfit: 0
  },
  {
    jobInfo: "E-934: Ximena Paz",
    leadSource: "Thumbtack",
    trade: "Siding",
    contractTotal: 6972.00,
    grossMarginPct: 0.4000,
    grossProfit: 2788.80,
    commissionPercentage: 4.00,
    salesCommission: 278.88,
    salesManagerFee: 69.72,
    companyOH: 1080.66,
    netProfit: 0
  },
  {
    jobInfo: "E-935: Renee & Eric Cooper",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 14972.00,
    grossMarginPct: 0.4215,
    grossProfit: 6310.70,
    commissionPercentage: 4.00,
    salesCommission: 598.88,
    salesManagerFee: 149.72,
    companyOH: 2320.66,
    netProfit: 0
  },
  {
    jobInfo: "Henry & Alice Allred",
    leadSource: "33 Mile Radius / Everconnect",
    trade: "Windows & Doors",
    contractTotal: 18038.00,
    grossMarginPct: 0.4211,
    grossProfit: 7595.80,
    commissionPercentage: 4.00,
    salesCommission: 721.52,
    salesManagerFee: 180.38,
    companyOH: 2795.89,
    netProfit: 0
  },
  {
    jobInfo: "James & Helen Loy",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 53500.00,
    grossMarginPct: 0.4000,
    grossProfit: 21400.00,
    commissionPercentage: 4.00,
    salesCommission: 2140.00,
    salesManagerFee: 535.00,
    companyOH: 8292.50,
    netProfit: 0
  },
  {
    jobInfo: "Rebecca Love & Richardson",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 5493.00,
    grossMarginPct: 0.4674,
    grossProfit: 2567.43,
    commissionPercentage: 4.00,
    salesCommission: 219.72,
    salesManagerFee: 54.93,
    companyOH: 851.42,
    netProfit: 0
  },
  {
    jobInfo: "Jill & James Delligatti",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 17423.00,
    grossMarginPct: 0.4769,
    grossProfit: 8309.03,
    commissionPercentage: 4.00,
    salesCommission: 696.92,
    salesManagerFee: 174.23,
    companyOH: 2700.57,
    netProfit: 0
  },
  {
    jobInfo: "Amy & Mike Porter",
    leadSource: "Events Division",
    trade: "Solar & Electrical",
    contractTotal: 55294.00,
    grossMarginPct: 0.4000,
    grossProfit: 22117.60,
    commissionPercentage: 4.00,
    salesCommission: 2211.76,
    salesManagerFee: 552.94,
    companyOH: 8570.57,
    netProfit: 0
  },
  {
    jobInfo: "Alvin & Kayla Brown",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2422.00,
    grossMarginPct: 0.4000,
    grossProfit: 968.80,
    commissionPercentage: 4.00,
    salesCommission: 96.88,
    salesManagerFee: 24.22,
    companyOH: 375.41,
    netProfit: 0
  },
  {
    jobInfo: "Bill Buslee",
    leadSource: "Events Division",
    trade: "Roofing",
    contractTotal: 14000.00,
    grossMarginPct: 0.4177,
    grossProfit: 5847.80,
    commissionPercentage: 4.00,
    salesCommission: 560.00,
    salesManagerFee: 140.00,
    companyOH: 2170.00,
    netProfit: 0
  },
  {
    jobInfo: "E-923: Crystal WALLS",
    leadSource: "Porch",
    trade: "Windows & Doors",
    contractTotal: 3999.00,
    grossMarginPct: 0.4850,
    grossProfit: 1939.52,
    commissionPercentage: 4.00,
    salesCommission: 159.96,
    salesManagerFee: 39.99,
    companyOH: 619.85,
    netProfit: 0
  },
  {
    jobInfo: "E-922: Dana Hudson",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 4799.00,
    grossMarginPct: 0.5672,
    grossProfit: 2721.99,
    commissionPercentage: 7.00,
    salesCommission: 335.93,
    salesManagerFee: 47.99,
    companyOH: 743.85,
    netProfit: 0
  },
  {
    jobInfo: "E-910: Greg & Shannon Fuller",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 3479.00,
    grossMarginPct: 0.4369,
    grossProfit: 1519.98,
    commissionPercentage: 4.00,
    salesCommission: 139.16,
    salesManagerFee: 34.79,
    companyOH: 539.25,
    netProfit: 0
  },
  {
    jobInfo: "E-906: Ajan Brown",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 5472.00,
    grossMarginPct: 0.4197,
    grossProfit: 2296.60,
    commissionPercentage: 4.00,
    salesCommission: 218.88,
    salesManagerFee: 54.72,
    companyOH: 848.16,
    netProfit: 0
  },
  {
    jobInfo: "E-941: Eric & Lenore Jones",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 3272.00,
    grossMarginPct: 0.5323,
    grossProfit: 1741.69,
    commissionPercentage: 7.00,
    salesCommission: 229.04,
    salesManagerFee: 32.72,
    companyOH: 507.16,
    netProfit: 0
  },
  {
    jobInfo: "E-930: Jeff & Sue Hubbard",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 5390.00,
    grossMarginPct: 0.6239,
    grossProfit: 3362.82,
    commissionPercentage: 10.00,
    salesCommission: 539.00,
    salesManagerFee: 53.90,
    companyOH: 835.45,
    netProfit: 0
  },
  {
    jobInfo: "E-914: John & Brenda Roff",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 5278.00,
    grossMarginPct: 0.6353,
    grossProfit: 3353.11,
    commissionPercentage: 10.00,
    salesCommission: 527.80,
    salesManagerFee: 52.78,
    companyOH: 818.09,
    netProfit: 0
  },
  {
    jobInfo: "E-940: Stephanie & Daniel Brosius",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 20972.00,
    grossMarginPct: 0.4079,
    grossProfit: 8554.48,
    commissionPercentage: 4.00,
    salesCommission: 838.88,
    salesManagerFee: 209.72,
    companyOH: 3250.66,
    netProfit: 0
  },
  {
    jobInfo: "E-936: Michael & Caleigh Guoynes",
    leadSource: "Thumbtack",
    trade: "Insulation",
    contractTotal: 2790.00,
    grossMarginPct: 0.5743,
    grossProfit: 1602.30,
    commissionPercentage: 7.00,
    salesCommission: 195.30,
    salesManagerFee: 27.90,
    companyOH: 432.45,
    netProfit: 0
  },
  {
    jobInfo: "E-925: Lillian & Theodore Tritle",
    leadSource: "Previous Customer",
    trade: "Gutters",
    contractTotal: 2500.00,
    grossMarginPct: 0.5476,
    grossProfit: 1369.00,
    commissionPercentage: 7.00,
    salesCommission: 175.00,
    salesManagerFee: 25.00,
    companyOH: 387.50,
    netProfit: 0
  },
  {
    jobInfo: "E-927: Erin Gebhart",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 11199.00,
    grossMarginPct: 0.7145,
    grossProfit: 8001.69,
    commissionPercentage: 10.00,
    salesCommission: 1119.90,
    salesManagerFee: 111.99,
    companyOH: 1735.85,
    netProfit: 0
  },
  {
    jobInfo: "E-921: Piper & James Moffatt",
    leadSource: "Angi",
    trade: "Roofing",
    contractTotal: 12653.00,
    grossMarginPct: 0.6463,
    grossProfit: 8177.63,
    commissionPercentage: 10.00,
    salesCommission: 1265.30,
    salesManagerFee: 126.53,
    companyOH: 1961.22,
    netProfit: 0
  },
  {
    jobInfo: "E-947: Caitlyn & Jose Carver",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 15295.00,
    grossMarginPct: 0.5711,
    grossProfit: 8734.97,
    commissionPercentage: 7.00,
    salesCommission: 1070.65,
    salesManagerFee: 152.95,
    companyOH: 2370.73,
    netProfit: 0
  },
  {
    jobInfo: "E-915: Ron & Therese Spake",
    leadSource: "Events Division",
    trade: "Insulation",
    contractTotal: 7447.65,
    grossMarginPct: 0.7640,
    grossProfit: 5690.00,
    commissionPercentage: 10.00,
    salesCommission: 744.77,
    salesManagerFee: 74.48,
    companyOH: 1154.39,
    netProfit: 0
  },
  {
    jobInfo: "E-924: Isaac & Sambeth Norville",
    leadSource: "Google Organic Search",
    trade: "Gutters",
    contractTotal: 2427.00,
    grossMarginPct: 0.6129,
    grossProfit: 1487.51,
    commissionPercentage: 10.00,
    salesCommission: 242.70,
    salesManagerFee: 24.27,
    companyOH: 376.19,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from March 2026 Ad Spend CSV
// Source: sample csv/2025 TLLG Marketing Leads Report - ROI Exteriors - AdSpendMar26.csv
// Note: Sales CSV header shows $64,942.54 (stale Jan value) — using ad spend CSV sum of $69,731.87 per Rule 6
const adSpendData = [
  { source: "Networx", spend: 577.52 },
  { source: "Thumbtack", spend: 3900.00 },
  { source: "Yelp", spend: 6766.79 },
  { source: "Porch", spend: 0.00 },
  { source: "Web to Lead Form", spend: 0.00 },
  { source: "Angi", spend: 5000.00 },
  { source: "Google Organic Search", spend: 5723.66 },
  { source: "Google Paid Search", spend: 38604.11 },
  { source: "Facebook / Meta Ads", spend: 2359.79 },
  { source: "Events Division", spend: 5000.00 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Other", spend: 0.00 },
  { source: "Blank", spend: 0.00 },
  { source: "Truck", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 0.00 },
  { source: "eLocal", spend: 1500.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

export const march2026Data: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit - totalAdSpend,
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: adSpendData,
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,

  period: {
    month: 3,
    year: 2026
  }
};
